import { Button, Typography, Box, Grid } from "@mui/material";

import { useState } from "react";

import { post } from "../../../utils/api";

import SelectField from "../../../Components/Masters/SelectField";

import InputField from "../../../Components/Masters/InputField";

import { validateNumber } from "../../../utils/validateFields";

const OTHER_VENDOR_ERROR =
  "Please select another name. 'Other' is not allowed.";

const isOtherVendorName = (value) =>
  String(value || "")
    .trim()
    .toLowerCase() === "other";

const BulkUploadAdd = ({
  onAddItem,
  setMatchData,
  index,
  errors,
  setErrors,
  setFormData,
  formData,
  setExpandedRows,
  bulkuploadInputData,
  submitUrl,
  inputData,
  value,
  data,
  setsnackOpen,
  matched,
}) => {
  const [regex] = useState({});

  const requiredLength = () => {
    const regexString = regex?.key1regex || "^[A-Za-z0-9]{15}$";

    const match = regexString.match(/\{(\d+)\}/);

    if (match) {
      return parseInt(match[1], 10);
    }
  };

  const validateVendorName = (name) => {
    const trimmed = String(name || "").trim();

    if (!trimmed) {
      return "Vendor Legal Name is required";
    }

    if (isOtherVendorName(trimmed)) {
      return OTHER_VENDOR_ERROR;
    }

    const vendor = data?.filter((el) =>
      new RegExp(`^${trimmed}$`, "i").test(el.vendorLegalName),
    );

    if (vendor.length > 0) {
      return "Vendor Legal Name already exists.";
    }

    return "";
  };

  const validateForm = (index) => {
    const newErrors = {};

    inputData?.forEach((input) => {
      const fieldValue = formData?.[index]?.[input.fieldName];

      if (input.fieldName === "vendorLegalName") {
        const vendorNameValue = formData?.[index]?.[input.fieldName] ?? "";

        if (isOtherVendorName(vendorNameValue)) {
          newErrors.vendorLegalName = OTHER_VENDOR_ERROR;

          return;
        }

        const vendorError = validateVendorName(vendorNameValue);

        if (vendorError) {
          newErrors[input.fieldName] = vendorError;
        }

        return;
      }

      if (input.fieldName === "contactNumber") {
        const mobileNo = formData?.[index]?.contactNumber?.mobileNo;

        if (!mobileNo) {
          newErrors[input.fieldName] = `${input.title} is required`;
        } else if (!validateNumber(mobileNo) || mobileNo?.length < 7) {
          newErrors[input.fieldName] = "Please enter valid Contact Number";
        }

        if (!formData?.[index]?.email) {
          newErrors[input.fieldName] = `${input.title} is required`;
        } else if (errors.email) {
          return;
        }
      } else if (input.fieldName === "gstNumber") {
        const reg = new RegExp(`^${fieldValue}$`, "i");

        const gst = data.filter((el) => reg.test(el.gstNumber));

        if (gst.length > 0) {
          newErrors[input.fieldName] = `${input.title} Already exists.`;
        }

        const regex1 = new RegExp(regex?.key1regex);

        if (fieldValue === "") {
          newErrors[input.fieldName] =
            `${regex?.key1 || input.title} is Required.`;
        } else if (
          fieldValue?.length !== requiredLength() ||
          !regex1.test(fieldValue)
        ) {
          newErrors[input.fieldName] = "Invalid Format";
        }
      } else if (!fieldValue || fieldValue === "") {
        newErrors[input.fieldName] = `${input.title} is required`;
      }
    });

    setErrors((prevState) => ({
      ...prevState,

      [index]: { ...prevState[index], ...errors, ...newErrors },
    }));

    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value: fieldValue } = e.target;

    setFormData((prevState) => ({
      ...prevState,

      [index]: {
        ...prevState[index],

        [name]:
          name === "contactNumber"
            ? { ...prevState[index]?.contactNumber, mobileNo: fieldValue }
            : fieldValue,
      },
    }));

    if (name === "vendorLegalName") {
      const trimmed = String(fieldValue || "").trim();

      if (isOtherVendorName(trimmed)) {
        setErrors((prevState) => ({
          ...prevState,
          [index]: {
            ...prevState[index],
            [name]: OTHER_VENDOR_ERROR,
          },
        }));
      } else if (trimmed) {
        const vendorError = validateVendorName(fieldValue);

        setErrors((prevState) => ({
          ...prevState,
          [index]: {
            ...prevState[index],
            [name]: vendorError,
          },
        }));
      } else {
        setErrors((prevState) => ({
          ...prevState,
          [index]: {
            ...prevState[index],
            [name]: "",
          },
        }));
      }
      return;
    }

    setErrors((prevState) => ({
      ...prevState,

      [index]: { ...prevState[index], [name]: "" },
    }));
  };

  const handleAddItem = async (index) => {
    if (!validateForm(index)) {
      return;
    }

    const itemData = {
      ...formData[index],
    };

    try {
      const response = await post(submitUrl, itemData);

      setsnackOpen({
        open: true,

        message: response.data.message,

        severity: "success",
      });

      await new Promise((resolve) => setTimeout(resolve, 1000));

      if (setMatchData) {
        setMatchData((prev) =>
          prev.map((item, i) =>
            i === index ? { ...item, [matched]: true } : item,
          ),
        );
      }

      if (onAddItem) {
        onAddItem(itemData, index);
      }

      setExpandedRows((prev) => ({
        ...prev,

        [index]: false,
      }));

      setFormData((prev) => {
        const newData = { ...prev };

        delete newData[index];

        return newData;
      });

      setErrors((prev) => {
        const newErrors = { ...prev };

        delete newErrors[index];

        return newErrors;
      });
    } catch (error) {
      console.error("Error adding vendor:", error);
    }
  };

  const getFieldValue = (fieldName) => formData[index]?.[fieldName] ?? "";

  return (
    <Box sx={{ margin: 1 }}>
      <Typography variant="h6" gutterBottom component="div">
        Add Vendor:
      </Typography>

      <Grid container spacing={2}>
        {bulkuploadInputData?.map((items) => (
          <Grid item xs={12} sm={6} key={items.fieldName}>
            {items.type === "text" || items.type === "number" ? (
              <InputField
                title={items.title}
                handleChange={handleChange}
                placeholder={items.placeholder}
                errors={errors?.[items.fieldName]}
                value={getFieldValue(items.fieldName)}
                fieldName={items.fieldName}
                disabled={items?.fieldName === "wasteManagementType"}
                type={items.type}
              />
            ) : (
              <SelectField
                title={items.title}
                name={items.fieldName}
                value={formData?.[index]?.[items.fieldName]}
                handleChange={handleChange}
                options={items?.options}
                errors={errors?.[items.fieldName]}
              />
            )}
          </Grid>
        ))}

        <Grid item xs={12}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleAddItem(index)}
              sx={{ mt: 1 }}
            >
              Add Vendor
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BulkUploadAdd;
